<!--
 * @Author: jingfei
 * @LastEditors: yingna.gao
 * @Date: 2021-08-12 18:58:32
 * @LastEditTime: 2022-12-23 19:44:14
 * @Description: file content
-->
<template>
  <div id="excel-label" class="app-wrap import_add_and_edit" style="overflow-y: scroll">
    <!-- <div class="add-edit-back">
      <Back style="margin-left: 21px;" />
    </div> -->

    <div class="add-edit-back-title-content">
      <div style="flex: 1;">
        <div class="add-edit-back-icon"></div>
        <div class="interface-title">
          {{ InterfaceTitle }}
        </div>
      </div>
      <div class="back themeGreen" @click="backPage">
        <i class="el-icon-back" style="margin-right: 4px" /> 返回
      </div>
    </div>

    <div class="excel-label">
      <el-form
        ref="excelForm"
        :label-position="labelPosition"
        :rules="rules"
        label-width="80px"
        size="small"
        :model="formLabelAlign"
      >
        <!-- 输入框 -->
        <el-row :gutter="20">
          <el-col :span="12" class="right-padding">
            <el-form-item :label="$t('excelConfiguration.code')" prop="code">
              <el-input
                v-model="formLabelAlign.code"
                :placeholder="$t('public.pleaseEnter')"
                max-length="64"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('excelConfiguration.datasource')" prop="datasourceId">
              <el-select
                v-model="formLabelAlign.datasourceId"
                :placeholder="$t('public.pleaseSelect')"
                style="width: 100%"
              >
                <el-option
                  v-for="item in datasourceList"
                  :key="item.id"
                  :label="item.datasourceName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('excelConfiguration.controllingThingsWay')" prop="transactionType">
              <!-- <el-input v-model="formLabelAlign.transactionType"></el-input> -->
              <el-select
                v-model="formLabelAlign.transactionType"
                :placeholder="$t('public.pleaseSelect')"
                style="width: 100%"
              >
                <el-option
                  v-for="item in transactionTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('excelConfiguration.userDefinedProcessingClass')">
              <el-input
                v-model="formLabelAlign.customClass"
                :placeholder="$t('public.pleaseEnter')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="left-padding">
            <el-form-item :label="$t('excelConfiguration.name')" prop="name">
              <el-input
                v-model="formLabelAlign.name"
                :placeholder="$t('public.pleaseEnter')"
                maxlength="64"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('excelConfiguration.configurationMethod')"
              style="margin-bottom: 0"
            >
              <!-- <el-checkbox v-model="formLabelAlign.manageStyle">EXCEL</el-checkbox> -->
              <el-radio v-model="formLabelAlign.manageStyle" label="EXCEL">EXCEL</el-radio>
              <!-- <el-radio v-model="formLabelAlign.manageStyle" disabled label="ENTITY">ENTITY</el-radio> -->
            </el-form-item>
            <el-form-item style="margin-bottom: 0" prop="uploadExcel">
              <!-- <el-button
                class="back-btn"
                type="primary"
                @click="openFileUploadModal"
                style="width: 100%;"
              >
                {{ $t("excelConfiguration.selectFile") }}
              </el-button> -->
              <el-upload
                ref="upload"
                style="width: 100%"
                class="upload"
                action=""
                :on-change="fileUpload"
                :show-file-list="false"
                :auto-upload="false"
                accept=".xlsx, .xls"
              >
                <el-button class="w100" style="padding: 9px 15px">
                  <svg-icon icon-class="upload" />
                  <span>{{ $t("excelConfiguration.selectFile") }}</span>
                </el-button>
              </el-upload>

              <div>
                <span v-show="attachmentStation" class="download_a" @click="downloadAttachment()">
                  下载模板
                </span>
                <!-- {{ attachmentStatistics }} -->
                <span class="download_tips">支持上传1个文件，最大为25M,支持xls、xlsx格式</span>
                <div v-if="!formLabelAlign.attachmentId" class="noAttachmentId">无附件</div>
              </div>
            </el-form-item>

            <div >
              <el-form-item label="">
                <div v-show="file" style="height: 43px" class="upload-file">
                  <svg-icon
                    v-show="uploadStatious"
                    icon-class="red-exclamation-mark"
                    class="icon-shape"
                  ></svg-icon>
                  <svg-icon
                    v-show="!uploadStatious"
                    icon-class="file-name-shape"
                    class="icon-shape"
                  ></svg-icon>
                  <span :title="file.name" class="text-overflow name">{{ file.name }}</span>
                  <span v-show="uploadStatious">（{{ $t("public.uploadFailed") }}）</span>
                  <div class="operation" style="float: right">
                    <i
                      v-show="lineColor === 'error'"
                      class="el-icon-refresh-right cursor-p lightText"
                      @click="handleRefresh"
                    />
                    <i
                      class="el-icon-close cursor-p lightText"
                      style="margin-left: 6px"
                      @click="handleDeleteFile"
                    />
                  </div>
                  <div
                    class="progress"
                    :style="{
                      width: '100' + '%',
                      backgroundColor:
                        lineColor === 'error'
                          ? '#E60000'
                          : lineColor === 'success'
                            ? '#00B259'
                            : '',
                      height: '2px'
                    }"
                  />
                </div>
              </el-form-item>
            </div>
            <el-form-item :label="$t('common.description')">
              <el-input
                v-model="formLabelAlign.description"
                type="textarea"
                :rows="2"
                :placeholder="`${$t('common.pleaseEnter')}内容(${$t('common.wordCountLimit', [
                  $getInputMaxLimitConst('limit100')
                ])})`"
                :maxlength="$getInputMaxLimitConst('limit100')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 按钮组 -->
      <div class="excel-label-btn" :style="{ width: '100%', marginTop: '12px' }">
        <el-form :inline="true" class="demo-form-inline" size="small" @submit.native.prevent>
          <el-form-item label=""></el-form-item>
          <!-- sheet按钮组 -->
          <el-form-item class="float-right" style="margin-right: 0">
            <el-button
              style="width: 80px"
              class="grey_button"
              @click="
                handleSaveAndBack({
                  type: 'back'
                })
              "
            >
              {{ $t("public.cancel") }}
            </el-button>
            <el-button
              style="width: 80px"
              type="primary"
              @click="
                handleSaveAndBack({
                  type: 'save'
                })
              "
            >
              {{ $t("public.save") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 文档 -->
      <!-- <div class="documentation" v-for="item in documentation" :key="item.labelTitle">
        <div class="excel-label-title">{{ item.labelTitle }} ：</div>
        <div class="heading" v-for="num in item.titleContent" :key="num.mainTitle">
          <div class="excel-label-main-title">{{ num.mainTitle }}：</div>
          <div class="excel-label-title-content">
            {{ num.mainTitleContent }}
          </div>
        </div>
      </div> -->
      <div class="documentation_box">
        <div v-for="item in documentation" :key="item.labelTitle" class="documentation_content">
          <span class="documentation_title">{{ item.mainTitle }}</span>
          {{ item.mainTitleContent }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Back from "@/components/common/Back/index";
import { mapGetters } from "vuex";
import excel_api from "@/api/excel/excel";
import Back from "@/components/common/Back";

export default {
  name: "ExcelAddEdit",
  components: {
    Back
  },
  props: {
    interfaceTitle: {
      type: String,
      default: "添加"
    },
    templateId: {
      type: [String, Object],
      default: null
    },
    attachmentId: {
      type: [String, Object],
      default: null
    }
  },
  data() {
    return {
      file: "",
      lineColor: "",
      uploadStatious: false,
      attachmentStation: false,
      attachmentStatistics: "已添加0个附件",
      shapeImg: require("@/assets/images/import-img/shape.png"),
      attachName: "",
      datasourceList: [],
      // 文档
      documentation: [
        {
          mainTitle: "Excel和DTO两种方式都开发用户自定义处理接口，具体使用如下:",
          mainTitleContent: ""
        },
        {
          mainTitle: "Excel方式:",
          mainTitleContent:
            "通过添加用户自定义处理类路径，该类需要实现接口sysexcleimpwithexclehandle,可根据需求实现不同方法，对不同阶段的数据进行干预处理。"
        },
        {
          mainTitle: "导入配置自定义数据转换接口:",
          mainTitleContent:
            "可通过自定义接口sysexcleimpwithexclehandler，对导入的excel数据做自定义切换。"
        }
      ],
      // 事物控制方式
      transactionTypeList: [
        {
          label: "全部成功",
          value: "ALL"
        },
        {
          label: "允许单行成功",
          value: "ROW"
        },
        {
          label: "允许SHEET成功",
          value: "SHEET"
        }
      ],
      // 页头的标签
      InterfaceTitle: "",
      // 表单label的位置
      labelPosition: "top",
      leftLabelPosition: "top",
      formLabelAlign: {
        code: "",
        name: "",
        transactionType: "",
        customClass: "",
        manageStyle: "EXCEL",
        attachmentId: "",
        description: "",
        datasourceId: "",
        uploadExcel: ""
      },
      // 校验是否为空或者不符合要求
      rules: {
        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        transactionType: [{ required: true, message: "请选择事物控制方式", trigger: "change" }],
        datasourceId: [{ required: true, message: "请选择数据源", trigger: "change" }]
      },
      uploadDialogVisible: false
    };
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  created() {
    this.getInterfaceInformation();
    this.getDatasource();
  },
  methods: {
    handleRefresh() {
      this.uploadStatious = false;
      this.fileUpload(this.file);
    },
    handleDeleteFile() {
      this.file = "";
      this.attachmentStatistics = "已添加0个附件";
      this.formLabelAlign.uploadExcel = null;
      this.formLabelAlign.attachmentId = "";
      this.attachmentStation = false;
    },
    // 条件查询数据源
    getDatasource() {
      const params = {};
      excel_api.getDatasource(params).then(res => {
        this.datasourceList = res.data;
      });
    },

    handleUploadChange(data) {
      this.formLabelAlign.attachmentId = data.data.id;
      this.attachName = data.data.attachName;
      this.attachmentStation = true;
      this.uploadDialogVisible = false;
    },

    openFileUploadModal() {
      this.uploadDialogVisible = true;
    },

    /**
     * @description: 从地址栏获取界面标题的信息
     * @param {*}
     * @return {*}
     */
    getInterfaceInformation() {
      this.InterfaceTitle = this.interfaceTitle;
      if (this.templateId !== "null") {
        const { templateId, attachmentId } = this;
        this.formLabelAlign.attachmentId = templateId;
        templateId && this.getConfigurationItem(templateId);
        attachmentId && this.getAttachmentRecord(attachmentId);
      }
    },

    /**
     * @description: 根据id查询模板配置
     * @param {*}
     * @return {*}
     */
    getConfigurationItem(ConfigurationId) {
      excel_api.getConfigurationListOfId(ConfigurationId).then(res => {
        this.formLabelAlign = res.data;
      });
    },

    /**
     * @description: 返回上一个界面，并刷新界面
     */
    backPage() {
      this.$emit("back");
    },

    /**
     * @description: 添加/编辑/属性设置
     * @param {*} data {
     *        type: ”add“--新增， ”edit“--编辑，
     *        data:type为save才会触发事件，调用保存的接口并返回上一个界面
     *                  }
     * @return {*}
     */
    handleSaveAndBack(data) {
      if (data.type === "back") {
        this.backPage();
      } else if (data.type === "save" && this.templateId === "null") {
        this.saveImportExcel();
      } else {
        this.updateConfiguration();
      }
    },

    // 查询附件记录
    getAttachmentRecord(Id) {
      excel_api.getAttachmentRecord(Id).then(res => {
        if (res.success && res.code === 200) {
          this.file = {};
          this.file.name = res.data.attachName;
          this.attachmentStation = true;
          this.attachmentStatistics = "已添加1个附件";
        }
      });
    },

    // 文件上传
    fileUpload(file) {
      this.file = file;
      this.lineColor = "null";
      this.attachmentStatistics = "已添加1个附件";
      const data = new FormData();
      data.append("file", file.raw);
      excel_api.updatingFiles(data).then(res => {
        if (res.success && res.code === 200) {
          this.$message({
            message: "文件上传成功",
            type: "success"
          });
          this.formLabelAlign.attachmentId = res.data.id;
          this.attachName = res.data.attachName;
          this.attachmentStation = true;
          this.uploadStatious = false;
          this.lineColor = "success";
          this.uploadDialogVisible = false;
        } else {
          this.uploadStatious = true;
          this.lineColor = "error";
          this.$message({
            message: "文件上传失败",
            type: "warning"
          });
        }
      });
    },

    // 附件下载
    downloadAttachment() {
      const { attachmentId } = this;

      excel_api.downloadAttachment(attachmentId).then(result => {
        const blob = new Blob([result.data], {
          type: "application/vnd.ms-excel"
        }); // 构造一个blob对象来处理数据
        const fileName = result.filename; // 导出文件名对于<a>标签，只有Firefox和Chrome（内核）支持download属性 IE10以上支持blob但是依然不支持download
        if ("download" in document.createElement("a")) {
          // 支持a标签download的浏览器
          const link = document.createElement("a"); // 创建a标签
          link.download = fileName; // a标签添加属性
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); // 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link); // 释放标签
        } else {
          // 其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },

    /**
     * @description: 保存导入的excel
     * @param {*}     }
     * @return {*}
     */
    saveImportExcel() {
      this.$refs["excelForm"].validate(valid => {
        if (valid) {
          const params = {
            code: this.formLabelAlign.code,
            name: this.formLabelAlign.name,
            transactionType: this.formLabelAlign.transactionType,
            customClass: this.formLabelAlign.customClass,
            manageStyle: this.formLabelAlign.manageStyle,
            attachmentId: this.formLabelAlign.attachmentId,
            id: this.formLabelAlign.id,
            description: this.formLabelAlign.description,
            datasourceId: this.formLabelAlign.datasourceId
          };
          excel_api.saveConfiguration(params).then(res => {
            if (res.success && res.code === 200) {
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.backPage();
            } else {
              this.$message({
                message: "保存失败",
                type: "warning"
              });
            }
          });
        }
      });
    },

    /**
     * @description: 更新导入的excel
     * @param {*}     }
     * @return {*}
     */
    updateConfiguration() {
      this.$refs["excelForm"].validate(valid => {
        if (valid) {
          const params = {
            code: this.formLabelAlign.code,
            name: this.formLabelAlign.name,
            id: this.templateId,
            transactionType: this.formLabelAlign.transactionType,
            customClass: this.formLabelAlign.customClass,
            manageStyle: this.formLabelAlign.manageStyle,
            attachmentId: this.formLabelAlign.attachmentId,
            description: this.formLabelAlign.description,
            datasourceId: this.formLabelAlign.datasourceId
          };
          excel_api.updateConfiguration(params).then(res => {
            if (res.success && res.code === 200) {
              this.$message({
                message: "更新成功",
                type: "success"
              });
              this.backPage();
            } else {
              this.$message({
                message: "更新失败",
                type: "warning"
              });
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.add-edit-back-title-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.back {
  line-height: 20px;
  display: inline-block;
  margin-bottom: 3px;
  font-size: 14px;
  cursor: pointer;
}
#excel-label .download_tips {
  color: #9ea5b2;
  font-size: 12px;
}
#excel-label .documentation_box {
  width: 100%;
  background-color: #f5f7fa;
  padding: 16px 24px;
  float: left;
  margin-top: 16px;
  .documentation_content {
    font-size: 12px;
    line-height: 24px;
    color: #777777;
    .documentation_title {
      color: #666666;
      font-weight: bold;
    }
  }
}
#excel-label {
  .grey_button {
    color: #585858;
    border-color: #d6d6d8;
  }
  .grey_button:hover {
    color: #fff;
    border: none;
  }
}
</style>

<style lang="scss">
.import_add_and_edit {
  .el-form {
    .el-input--small {
      .el-input__inner,
      .el-textarea__inner {
        padding-left: 8px;
      }
    }
  }
}
.noAttachmentId{
  color:#e60000;
  line-height: 14px;
}
</style>
